module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shared-fields-participant-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Select fields to share with " + _vm._s(_vm.participantSingularName))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.fieldsToShare), function(field) {
    return _c('div', {
      key: field.name,
      staticClass: "col-md-3"
    }, [_c('label', {
      staticClass: "mt-checkbox mt-checkbox-outline",
      attrs: {
        "id": 'hide-' + field.name
      }
    }, [_vm._v("\n              " + _vm._s(field.description) + "\n              "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.by_participant),
        expression: "field.by_participant"
      }],
      attrs: {
        "name": field.name,
        "type": "checkbox"
      },
      domProps: {
        "value": true,
        "checked": Array.isArray(field.by_participant) ? _vm._i(field.by_participant, true) > -1 : (field.by_participant)
      },
      on: {
        "change": function($event) {
          var $$a = field.by_participant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = true,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(field, "by_participant", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(field, "by_participant", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(field, "by_participant", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span')])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d68d88c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ShareFieldsWithParticipantModal.vue
// module id = 1744
// module chunks = 1